import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { isEmpty } from "lodash";
import { KeyboardArrowDown, KeyboardArrowUp, Delete } from "@material-ui/icons";
import { TEXTURE_MAP_LIST } from "../../constants";
import SelectDropdown from "./SelectDropdown";
import { uploadFileToS3 } from "../../modules/SKUClient";
import Accordion from "./Accordion";
import TextureMap from "./TextureMap";

export default function MaterialTextureInteraction({
  getMaterialNames,
  getAssetUrl,
  getContextData,
  currentConfig = {},
  updateConfig,
  configType,
  applyTexture,
  templateConfig,
}) {
  const [materials, setMaterials] = useState([]);
  const [isLoading, setLoading] = useState(false);
  // const [materialConfig, setMaterialConfig] = useState({ ...currentConfig });

  useEffect(() => {
    if (!isEmpty(currentConfig)) {
      setMaterials([...Object.keys(currentConfig)]);
      // setMaterialConfig(currentConfig ? { ...currentConfig } : {});
    }
  }, [currentConfig]);

  const addMaterial = (materialName) => {
    const materialConfigCurrent = { ...currentConfig } ?? {};
    setMaterials(materials ? [...materials, materialName] : []);
    materialConfigCurrent[materialName] = {};
    // setMaterialConfig(materialConfigCurrent);
    updateConfig({ ...materialConfigCurrent });
  };

  const addMap = (materialName, mapKey) => {
    const materialConfigCurrent = { ...currentConfig } ?? {};
    if (!materialConfigCurrent[materialName])
      materialConfigCurrent[materialName] = {};
    materialConfigCurrent[materialName][mapKey] = "";
    // setMaterialConfig(materialConfigCurrent);
    updateConfig({ ...materialConfigCurrent });
  };

  const getRemainingMaterials = () => {
    const allMaterials = getMaterialNames();
    return allMaterials.filter((e) => !materials.includes(e));
  };

  const onRemoveMaterial = (material) => {
    const updatedMaterials = materials.filter((m) => material !== m);
    const updatedConfig = Object.keys({ ...currentConfig })
      .filter((key) => updatedMaterials.includes(key))
      .reduce((obj, key) => {
        obj[key] = currentConfig[key];
        return obj;
      }, {});
    console.log(
      "🚀 ~ file: MaterialTextureInteraction.js ~ line 49 ~ onRemoveMaterial ~ updatedConfig",
      updatedConfig
    );
    setMaterials([...updatedMaterials]);
    // setMaterialConfig({ ...updatedConfig });
    updateConfig({ ...updatedConfig }, true);
  };

  const onRemoveMap = (material, mapType) => {
    const updatedMaterialConfig = currentConfig;
    let updatedMapConfig = Object.keys(updatedMaterialConfig[material]);
    updatedMapConfig = updatedMapConfig
      .filter((key) => ![mapType, `${mapType}Intensity`].includes(key))
      .reduce((obj, key) => {
        obj[key] = updatedMaterialConfig[material][key];
        return obj;
      }, {});

    if (isEmpty(updatedMapConfig)) {
      const updatedMaterials = materials.filter((m) => material !== m);
      setMaterials(updatedMaterials);
    }
    updatedMaterialConfig[material] = updatedMapConfig;
    // setMaterialConfig({ ...updatedMaterialConfig });
    updateConfig({ ...updatedMaterialConfig });
  };

  const getRemainingMap = (itemList) => {
    return Object.keys(TEXTURE_MAP_LIST)
      .filter((e) => !itemList.includes(e))
      .map((key) => {
        return { value: key, label: TEXTURE_MAP_LIST[key] };
      });
  };

  const uploadFileData = async (file, mapType, material) => {
    const { skuId, clientId } = getContextData();
    const category = `Texture_${mapType}`;
    const fileUrl = await uploadFileToS3(file, skuId, clientId, category);
    const updatedConfig = { ...currentConfig };
    if (fileUrl) {
      updatedConfig[material][mapType] = fileUrl;
      // setMaterialConfig({ ...updatedConfig });
      updateConfig(updatedConfig);
    } else {
      onRemoveMaterial(material);
    }
    applyTexture(material, { [mapType]: fileUrl });
    setLoading(false);
    templateConfig.updateAssetsLoadingState(false);
  };

  const MaterialComponent = () => {
    return (
      <div className="componentContainer">
        <SelectDropdown
          menuList={getRemainingMaterials()}
          placeholder="Select Materials"
          onMenuSelect={(value) => addMaterial(value)}
        />
        <div className="formSelector">
          {materials.map((material) => {
            return (
              <div key={material} className="materialContainer">
                <div className="materialHeader">
                  <div className="materialTitle">{material}</div>
                  <div className="actions">
                    <Button
                      variant="secondary"
                      onClick={() => onRemoveMaterial(material)}
                    >
                      <Delete fontSize="small" />
                    </Button>
                  </div>
                </div>
                <div className="textureWrapper">
                  <div className="advancedOptions">
                    <div className="selectedMapList">
                      {currentConfig &&
                        currentConfig[material] &&
                        Object.keys(currentConfig[material])?.map((mapType) => {
                          console.log(currentConfig, "materialConfig");
                          if (/Intensity/.test(mapType)) return null;
                          return (
                            <TextureMap
                              key={`${mapType}`}
                              name={TEXTURE_MAP_LIST[mapType]}
                              configType={configType}
                              mapType={mapType}
                              assetId={currentConfig[material][mapType]}
                              intensity={
                                currentConfig[material][
                                  `${mapType}Intensity`
                                ] || 0
                              }
                              onRemoveMap={(map) => onRemoveMap(material, map)}
                              getAssetUrl={getAssetUrl}
                              uploadFileData={(file) => {
                                setLoading(true);
                                templateConfig.updateAssetsLoadingState(true);
                                uploadFileData(file, mapType, material);
                              }}
                              updateMaterialIntensity={(key, value) => {
                                const updatedConfig = { ...currentConfig };
                                updatedConfig[material][key] = value;
                                // setMaterialConfig({ ...updatedConfig });
                                updateConfig({ ...updatedConfig });
                              }}
                            />
                          );
                        })}
                    </div>
                    <SelectDropdown
                      menuList={getRemainingMap(
                        currentConfig[material]
                          ? Object.keys(currentConfig[material])
                          : []
                      )}
                      onMenuSelect={(value, label) => {
                        addMap(material, value, label);
                      }}
                      className="mapSelector"
                      placeholder="Select Map"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="materialTextureInteraction">
      {isLoading && (
        <div className="loadingMaterialOverlay">
          <div className="loadingContainer">
            <div className="loader" />
          </div>
        </div>
      )}
      <Accordion
        expandIcon={({ isActive }) =>
          isActive ? <KeyboardArrowUp /> : <KeyboardArrowDown />
        }
        className="material-texture-accordion"
        panelList={[
          {
            header: "Modify Material Interaction",
            headerClass: "material-texture-accordion-header",
            component: <MaterialComponent />,
          },
        ]}
      />
    </div>
  );
}
